import { render } from "./Notification.vue?vue&type=template&id=64c6dcae&scoped=true&ts=true"
import script from "./Notification.ts?vue&type=script&lang=ts"
export * from "./Notification.ts?vue&type=script&lang=ts"

import "./Notification.scss?vue&type=style&index=0&id=64c6dcae&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c6dcae"]])

export default __exports__